export default __webpack_public_path__ + "static/media/go-logo.4c88fbf9.svg";